export default __webpack_public_path__ + "static/media/image-work-personal-m@3x.51c737d4.png";